import LanguageSettingsProvider from "providers/LanguageSettingsProvider"
import LanguageSettingsTemplate from "components/templates/LanguageSettingsTemplate"

const LanguageSettings = () => {
  return <LanguageSettingsProvider>
    <LanguageSettingsTemplate />
  </LanguageSettingsProvider>
}

export default LanguageSettings
